// extracted by mini-css-extract-plugin
module.exports = {"mobileView":"DrivingskillsPage_mobileView__19FI6","imageBox":"DrivingskillsPage_imageBox__2UThK","theoryPageTopContent":"DrivingskillsPage_theoryPageTopContent__2tYPc"};